var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFreeTagRed2Grey0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6102 1.70342C9.76128 1.74985 9.87667 1.8678 9.91685 2.01687L12.1079 10.146C12.1734 10.3893 12.0228 10.6414 11.7714 10.7091L3.57805 12.9175C3.32666 12.9852 3.06972 12.843 3.00416 12.5997L0.813144 4.47056C0.772964 4.32148 0.813448 4.16152 0.920729 4.04546L4.32296 0.364788C4.44824 0.229258 4.64268 0.17685 4.8191 0.231065L9.6102 1.70342Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61864 8.04506L4.76764 8.59788L4.5064 8.66829L4.35977 8.12425C3.96097 8.21291 3.56685 8.17795 3.17969 7.81639L3.45264 7.50752C3.7447 7.76294 3.95492 7.83805 4.26635 7.77764L3.9648 6.65885C3.4898 6.64098 2.9956 6.60476 2.84424 6.04317C2.71653 5.56933 3.02045 5.18151 3.52136 5.01356L3.43385 4.68889L3.69509 4.61848L3.78378 4.94754C4.11646 4.89552 4.44535 4.95277 4.72825 5.19183L4.50519 5.49197C4.30261 5.3395 4.09919 5.27197 3.87601 5.28976L4.14445 6.28571C4.62506 6.30677 5.1417 6.35576 5.3037 6.95684C5.44442 7.47894 5.12367 7.85718 4.61864 8.04506ZM4.5264 7.70284C4.82245 7.5854 5.01131 7.36979 4.93326 7.08022C4.8493 6.76871 4.57355 6.69714 4.24851 6.6718L4.5264 7.70284ZM3.61241 5.3514C3.30957 5.46126 3.14049 5.66213 3.21499 5.93854C3.28594 6.20178 3.5425 6.25499 3.86074 6.27275L3.61241 5.3514Z",
    fill: "#2263C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22067 6.67998C9.6446 8.25288 9.26062 9.25995 8.19133 9.54815C7.12203 9.83635 6.28396 9.15866 5.86003 7.58576C5.44142 6.03262 5.76604 4.96389 6.87518 4.66495C7.97768 4.3678 8.80206 5.12684 9.22067 6.67998ZM6.73008 7.35126C7.04226 8.50954 7.46224 9.0105 8.00685 8.86371C8.55146 8.71693 8.66281 8.07277 8.35062 6.91448C8.02602 5.71014 7.60249 5.19602 7.05788 5.3428C6.51327 5.48959 6.40547 6.14692 6.73008 7.35126Z",
    fill: "#2263C5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTagRed2Grey0);
export default __webpack_public_path__ + "static/media/freeTag_red2_grey0.56cd34d7.svg";
export { ForwardRef as ReactComponent };